import { HttpClient, HttpParams } from '@angular/common/http';
import {Injectable} from '@angular/core';
import {Observable} from 'rxjs';
import {map} from 'rxjs/operators';
import { blockUi } from "@bndes/bndes-ux4/bndes-angular-utils";
import { ResultadoConsultaErros } from '../model/ResultadoConsultaErros';

@Injectable({
  providedIn: 'root'
})
export class ErroService {

  private BASE_URL = './rest/seguro/erros';

  constructor(private http: HttpClient) {
  }

  ultimosErrosDoDocumento(idDoc: number): Observable<ResultadoConsultaErros> {
    return this.http.get(`${this.BASE_URL}/documento/${idDoc}`, blockUi()).pipe(map(r => Object.assign(new ResultadoConsultaErros(), r)));
  }

}
